import React from 'react';
import PropTypes from 'prop-types';
import classes from './style.module.scss';

export default function Container({ children }) {
  return <div className={classes.container}>{children}</div>;
}

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};
